import { gql } from 'apollo-boost';

const manyQuery = gql`
  query certifications($inputFilter: CertificationsFilterInputType) {
    certifications(inputFilter: $inputFilter) {
      id
      name
      section
      status
      venue
      clubId
      examiners
      startedAt
      closedAt
      createdAt
      club {
        id
        shortName
      }
      sectionObj {
        name
      }
    }
  }
`;

const oneQuery = gql`
  query certificate($id: Int!) {
    certificate(id: $id) {
      id
      name
      section
      status
      venue
      clubId
      examiners
      startedAt
      closedAt
      club {
        id
        shortName
      }
      sectionObj {
        name
      }
    }
  }
`;

export const createMutation = gql`
  mutation createCertifications($inputData: CertificationInputType!) {
    createCertifications(inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const updateMutation = gql`
  mutation updateCertifications(
    $id: Int!
    $inputData: CertificationInputType!
  ) {
    updateCertifications(id: $id, inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const closeMutation = gql`
  mutation closeCertifications($id: Int!) {
    closeCertifications(id: $id) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;
export const openMutation = gql`
  mutation openCertifications($id: Int!) {
    openCertifications(id: $id) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const deleteMutation = gql`
  mutation deleteCertifications($id: Int!) {
    deleteCertifications(id: $id) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const undeleteMutation = gql`
  mutation undeleteCertifications($id: Int!) {
    undeleteCertifications(id: $id) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const generateProfileInfoMutation = gql`
  mutation generateCertificationsPdf($id: Int!, $trainerId: Int!) {
    generateCertificationsPdf(id: $id, trainerId: $trainerId) {
      ok
      url
      errors {
        field
        messages
      }
    }
  }
`;

export const generateProtocolXlsMutation = gql`
  mutation generateProtocolXls($certificationId: Int!) {
    generateProtocolXls(certificationId: $certificationId) {
      ok
      url
      errors {
        code
        field
        messages
      }
    }
  }
`;

const CERTIFICATION = {
  manyQuery,
  oneQuery,
  createMutation,
  updateMutation,
  closeMutation,
  openMutation,
  deleteMutation,
  undeleteMutation,
  generateProfileInfoMutation,
  generateProtocolXlsMutation,
};

export default CERTIFICATION;
